import React, {useEffect, useState} from "react";
import axios, {baseUrl, ipAddress, userName} from "../Univ";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
function UserProfile() {
    const [loading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);
    const [rows, setRows] = useState([]);
    const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState({
        user: "",
        role: "FARMER",
        name: "",
        mobile: "",
        alternate_mobile: "",
        email: "",
        address: "",
        location: "",
        village: "",
        taluk: "",
        district: "",
        state: "",
        country: "India",
        pincode: "",
        aadhaar_no: "",
        pan_no: "",
        gst_no: "",
        bank_name: "",
        account_no: "",
        ifsc_code: "",
        upi_id: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress
    });
    useEffect(() => {
        fetchProfiles();
        fetchUsers();
    }, []);
    const fetchProfiles = async () => {
        setLoading(true);
        try {
            const res = await axios.get(baseUrl + "user-profile/");
            setRows(res.data);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    };
    const fetchUsers = async () => {
        try {
            const res = await axios.get(baseUrl + "user-search/");
            setUsers(res.data);
        } catch (err) {
            console.log(err);
        }
    };
    // ==========================================
    // HANDLE CHANGE
    // ==========================================
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData, [name]: value
        });
    };
    // ==========================================
    // RESET
    // ==========================================
    const resetForm = () => {
        setEditId(null);
        setFormData({
            user: "",
            role: "FARMER",
            name: "",
            mobile: "",
            alternate_mobile: "",
            email: "",
            address: "",
            location: "",
            village: "",
            taluk: "",
            district: "",
            state: "",
            country: "India",
            pincode: "",
            aadhaar_no: "",
            pan_no: "",
            gst_no: "",
            bank_name: "",
            account_no: "",
            ifsc_code: "",
            upi_id: "",
            status: 1,
            addedby: userName,
            ip_add: ipAddress
        });
    };
    // ==========================================
    // SAVE / UPDATE
    // ==========================================
    const saveData = async () => {
        try {
            const fd = new FormData();
            Object.keys(formData).forEach(key => {
                fd.append(key, formData[key]);
            });
            if (editId === null) {
                await axios.post(baseUrl + "user-profile/", fd);
                Swal.fire({
                    icon: "success", title: "User Profile Created", timer: 1500, showConfirmButton: false
                });
            } else {
                await axios.put(baseUrl + "update-user-profile/" + editId + "/", fd);
                Swal.fire({
                    icon: "success", title: "User Profile Updated", timer: 1500, showConfirmButton: false
                });
            }
            resetForm();
            fetchProfiles();
        } catch (err) {
            console.log(err);
            Swal.fire("Error", "Unable to Save", "error");
        }
    };
    // ==========================================
    // EDIT
    // ==========================================
    const editProfile = (row) => {
        setEditId(row.id);
        setFormData({
            user: row.user?.id || row.user,
            role: row.role,
            name: row.name,
            mobile: row.mobile,
            alternate_mobile: row.alternate_mobile,
            email: row.email,
            address: row.address,
            location: row.location,
            village: row.village,
            taluk: row.taluk,
            district: row.district,
            state: row.state,
            country: row.country,
            pincode: row.pincode,
            aadhaar_no: row.aadhaar_no,
            pan_no: row.pan_no,
            gst_no: row.gst_no,
            bank_name: row.bank_name,
            account_no: row.account_no,
            ifsc_code: row.ifsc_code,
            upi_id: row.upi_id,
            status: row.status,
            addedby: userName,
            ip_add: ipAddress
        });
    };
    // ==========================================
    // DELETE
    // ==========================================
    const deleteProfile = (id) => {
        Swal.fire({
            title: "Delete User?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(baseUrl + "update-user-profile/" + id + "/");
                    Swal.fire("Deleted", "", "success");
                    fetchProfiles();
                } catch (err) {
                    Swal.fire("Error", "Unable to Delete", "error");
                }
            }
        });
    };
    // ==========================================
    // DASHBOARD
    // ==========================================
    const totalUsers = rows.length;
    const activeUsers = rows.filter(x => Number(x.status) === 1).length;
    const inactiveUsers = rows.filter(x => Number(x.status) !== 1).length;
    const farmers = rows.filter(x => x.role === "FARMER").length;
    const columns = [{
        field: "id", headerName: "ID", width: 80
    }, {
        field: "username", headerName: "Username", width: 140, renderCell: (params) => params.row.user?.username
    }, {
        field: "name", headerName: "Name", width: 200
    }, {
        field: "role", headerName: "Role", width: 150
    }, {
        field: "mobile", headerName: "Mobile", width: 140
    }, {
        field: "email", headerName: "Email", width: 220
    }, {
        field: "district", headerName: "District", width: 150
    }, {
        field: "state", headerName: "State", width: 150
    }, {
        field: "status",
        headerName: "Status",
        width: 120,
        renderCell: (params) => params.row.status === 1 ? <span className="badge bg-success">
                    Active
                </span> : <span className="badge bg-danger">
                    Inactive
                </span>
    }, {
        field: "action", headerName: "Action", width: 220, renderCell: (params) => (<>

            <button

                className="btn btn-warning btn-sm me-2"

                onClick={() => editData(params.row)}

            >

                Edit

            </button>

            <button

                className="btn btn-danger btn-sm"

                onClick={() => deleteData(params.row.id)}

            >

                Delete

            </button>

        </>)
    }];
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            user: row.user?.id || "",
            role: row.role,
            name: row.name,
            mobile: row.mobile,
            alternate_mobile: row.alternate_mobile,
            email: row.email,
            address: row.address,
            location: row.location,
            village: row.village,
            taluk: row.taluk,
            district: row.district,
            state: row.state,
            country: row.country,
            pincode: row.pincode,
            aadhaar_no: row.aadhaar_no,
            pan_no: row.pan_no,
            gst_no: row.gst_no,
            bank_name: row.bank_name,
            account_no: row.account_no,
            ifsc_code: row.ifsc_code,
            upi_id: row.upi_id,
            status: row.status
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete User?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .delete(baseUrl + "update-user-profile/" + id + "/")
                    .then(() => {
                        Swal.fire("Deleted", "User removed successfully", "success");
                    });
            }
        });
    };
    const fetchLocation = () => {
        navigator.geolocation.getCurrentPosition(async (position) => {
            const lat = Number(position.coords.latitude).toFixed(7);
            const lng = Number(position.coords.longitude).toFixed(7);
            const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`);
            const data = await response.json();
            const addr = data.address;
            setFormData(prev => ({
                ...prev,
                latitude: lat,
                longitude: lng,
                address: data.display_name,
                village: addr.village || addr.hamlet || "",
                taluk: addr.suburb || addr.county || "",
                district: addr.state_district || addr.county || "",
                state: addr.state || "",
                country: addr.country || "",
                pincode: addr.postcode || ""
            }));
        }, () => {
            Swal.fire("Error", "Unable to fetch location", "error");
        });
    };
    return (<div className="container-fluid mt-3">

        {/* ================= SUMMARY ================= */}

        <div className="row mb-4">

            <div className="col-md-3">

                <div className="card shadow">

                    <div className="card-body text-center">

                        <h6 className="text-muted">

                            Total Users

                        </h6>

                        <h2 className="text-primary">

                            {totalUsers}

                        </h2>

                    </div>

                </div>

            </div>

            <div className="col-md-3">

                <div className="card shadow">

                    <div className="card-body text-center">

                        <h6 className="text-muted">

                            Active Users

                        </h6>

                        <h2 className="text-success">

                            {activeUsers}

                        </h2>

                    </div>

                </div>

            </div>

            <div className="col-md-3">

                <div className="card shadow">

                    <div className="card-body text-center">

                        <h6 className="text-muted">

                            Inactive Users

                        </h6>

                        <h2 className="text-danger">

                            {inactiveUsers}

                        </h2>

                    </div>

                </div>

            </div>

            <div className="col-md-3">

                <div className="card shadow">

                    <div className="card-body text-center">

                        <h6 className="text-muted">

                            Farmers

                        </h6>

                        <h2 style={{color: "#ff9800"}}>

                            {farmers}

                        </h2>

                    </div>

                </div>

            </div>

        </div>

        {/* ================= FORM ================= */}

        <div className="card shadow mb-4">

            <div className="card-header bg-success text-white">

                <h5 className="mb-0">

                    {editId === null ? "Create User Profile" : "Edit User Profile"}

                </h5>

            </div>

            <div className="card-body">

                <div className="row">

                    <div className="col-md-3 mb-3">

                        <label>

                            Login User

                        </label>

                        <select

                            className="form-select"

                            name="user"

                            value={formData.user}

                            onChange={handleChange}

                        >

                            <option value="">

                                Select Login User

                            </option>

                            {users.map((item) => (<option

                                key={item.id}

                                value={item.id}

                            >

                                {item.username}

                            </option>))}

                        </select>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label>

                            Role

                        </label>

                        <select

                            className="form-select"

                            name="role"

                            value={formData.role}

                            onChange={handleChange}

                        >

                            <option value="FARMER">Farmer</option>

                            <option value="BUYER">Buyer</option>

                            <option value="SUPPLIER">Supplier</option>

                            <option value="TRANSPORTER">Transporter</option>

                            <option value="WAREHOUSE">Warehouse</option>

                            <option value="MACHINERY">Machinery Owner</option>

                            <option value="FPO">FPO</option>

                            <option value="CONSULTANT">Consultant</option>

                            <option value="DEALER">Dealer</option>

                            <option value="ADMIN">Admin</option>

                        </select>

                    </div>

                    <div className="col-md-3 mb-3">

                        <label>

                            Full Name

                        </label>

                        <input

                            className="form-control"

                            name="name"

                            value={formData.name}

                            onChange={handleChange}

                        />

                    </div>

                    <div className="col-md-3 mb-3">

                        <label>

                            Mobile

                        </label>

                        <input

                            className="form-control"

                            name="mobile"

                            value={formData.mobile}

                            onChange={handleChange}

                        />

                    </div>

                </div>
                <div className="row">

                <div className="col-md-3 mb-3">

                    <label>

                        Alternate Mobile

                    </label>

                    <input

                        className="form-control"

                        name="alternate_mobile"

                        value={formData.alternate_mobile}

                        onChange={handleChange}

                    />

                </div>

                <div className="col-md-3 mb-3">

                    <label>

                        Email

                    </label>

                    <input

                        type="email"

                        className="form-control"

                        name="email"

                        value={formData.email}

                        onChange={handleChange}

                    />

                </div>
                </div>

                <div className="card mb-4">

                    <div className="card-header bg-success text-white">

                        Address & GPS

                    </div>

                    <div className="card-body">

                        <div className="row align-items-end">

                            <div className="col-md-3 mb-3">

                                <label>Latitude</label>

                                <input
                                    className="form-control"
                                    value={formData.latitude}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Longitude</label>

                                <input
                                    className="form-control"
                                    value={formData.longitude}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <button
                                    type="button"
                                    className="btn btn-success w-100"
                                    onClick={fetchLocation}
                                >

                                    📍 Get Current Location

                                </button>

                            </div>

                        </div>

                        <div className="row">

                            <div className="col-md-12 mb-3">

                                <label>Complete Address</label>

                                <textarea
                                    rows="2"
                                    className="form-control"
                                    name="address"
                                    value={formData.address}
                                    readOnly
                                />

                            </div>

                        </div>

                        <div className="row">

                            <div className="col-md-3 mb-3">

                                <label>Village</label>

                                <input
                                    className="form-control"
                                    value={formData.village}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Taluk</label>

                                <input
                                    className="form-control"
                                    value={formData.taluk}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>District</label>

                                <input
                                    className="form-control"
                                    value={formData.district}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Pincode</label>

                                <input
                                    className="form-control"
                                    value={formData.pincode}
                                    readOnly
                                />

                            </div>

                        </div>

                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label>State</label>

                                <input
                                    className="form-control"
                                    value={formData.state}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-6 mb-3">

                                <label>Country</label>

                                <input
                                    className="form-control"
                                    value={formData.country}
                                    readOnly
                                />

                            </div>

                        </div>

                    </div>

                </div>
                </div>
                </div>




            <div className="card mb-4">

                <div className="card-header bg-info text-white">

                    Identity Details

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-4 mb-3">

                            <label>

                                Aadhaar No

                            </label>

                            <input

                                className="form-control"

                                name="aadhaar_no"

                                value={formData.aadhaar_no}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>

                                PAN No

                            </label>

                            <input

                                className="form-control"

                                name="pan_no"

                                value={formData.pan_no}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>

                                GST No

                            </label>

                            <input

                                className="form-control"

                                name="gst_no"

                                value={formData.gst_no}

                                onChange={handleChange}

                            />

                        </div>

                    </div>

                </div>

            </div>
            {/* ========================================= */}
            {/* BANK DETAILS */}
            {/* ========================================= */}
            <div className="card mb-4">

                <div className="card-header bg-warning">

                    Bank Details

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-3 mb-3">

                            <label>

                                Bank Name

                            </label>

                            <input

                                className="form-control"

                                name="bank_name"

                                value={formData.bank_name}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>

                                Account No

                            </label>

                            <input

                                className="form-control"

                                name="account_no"

                                value={formData.account_no}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>

                                IFSC Code

                            </label>

                            <input

                                className="form-control"

                                name="ifsc_code"

                                value={formData.ifsc_code}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>

                                UPI ID

                            </label>

                            <input

                                className="form-control"

                                name="upi_id"

                                value={formData.upi_id}

                                onChange={handleChange}

                            />

                        </div>

                    </div>

                </div>

            </div>
            {/* ========================================= */}
            {/* STATUS */}
            {/* ========================================= */}
            <div className="card mb-4">

                <div className="card-header bg-secondary text-white">

                    Status

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-3">

                            <label>

                                Status

                            </label>

                            <select

                                className="form-select"

                                name="status"

                                value={formData.status}

                                onChange={handleChange}

                            >

                                <option value={1}>

                                    Active

                                </option>

                                <option value={0}>

                                    Inactive

                                </option>

                            </select>

                        </div>

                    </div>

                </div>

            </div>
            {/* ========================================= */}
            {/* SAVE BUTTON */}
            {/* ========================================= */}
            <div className="text-end mb-4">

                <button

                    className="btn btn-success px-5"

                    onClick={saveData}

                >

                    {editId === "" ? "Save User" : "Update User"}

                </button>

            </div>
            {/* ========================================= */}
            {/* USER LIST */}
            {/* ========================================= */}
            <div className="card">

                <div className="card-header bg-dark text-white">

                    User Profile List

                </div>

                <div className="card-body">

                    <ERPDataGrid

                        rows={rows}

                        columns={columns}

                        loading={loading}

                        getRowId={(row) => row.id}

                    />

                </div>

            </div>
        </div>

        )

        }
        export default UserProfile;